var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 20.1666H13.75C18.3333 20.1666 20.1667 18.3332 20.1667 13.7499V8.24992C20.1667 3.66658 18.3333 1.83325 13.75 1.83325H8.25C3.66667 1.83325 1.83333 3.66658 1.83333 8.24992V13.7499C1.83333 18.3332 3.66667 20.1666 8.25 20.1666Z",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71917 13.2825L8.90083 10.45C9.2125 10.0467 9.79 9.97336 10.1933 10.285L11.8708 11.605C12.2742 11.9167 12.8517 11.8434 13.1633 11.4492L15.2808 8.71753",
    stroke: "#A19FCB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reports-icon.d9824438d894cb5549ceac5856eb44c4.svg";
export { ForwardRef as ReactComponent };